export const isLoadingSelector = (state) => state.reducer.isLoading;
export const tasksSelector = (state) => state.reducer.tasks;
export const tokenSelector = (state) => state.reducer.token;
export const allTaskCountSelector = (state) => state.reducer.allTaskCount;
export const errorLoginSelector = (state) => state.reducer.errorsLogin;
